var t;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(t || (t = {}));
var n;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(n || (n = {}));
function r(e) {
  return e.type === t.literal;
}
function u(e) {
  return e.type === t.argument;
}
function i(e) {
  return e.type === t.number;
}
function m(e) {
  return e.type === t.date;
}
function l(e) {
  return e.type === t.time;
}
function a(e) {
  return e.type === t.select;
}
function o(e) {
  return e.type === t.plural;
}
function p(e) {
  return e.type === t.pound;
}
function c(e) {
  return e.type === t.tag;
}
function f(e) {
  return !!(e && typeof e == "object" && e.type === n.number);
}
function s(e) {
  return !!(e && typeof e == "object" && e.type === n.dateTime);
}
export {
  n as SKELETON_TYPE,
  t as TYPE,
  u as isArgumentElement,
  m as isDateElement,
  s as isDateTimeSkeleton,
  r as isLiteralElement,
  i as isNumberElement,
  f as isNumberSkeleton,
  o as isPluralElement,
  p as isPoundElement,
  a as isSelectElement,
  c as isTagElement,
  l as isTimeElement
};
